export const API_URL = process.env.API_URL || 'http://localhost:8080/v1'

function getConfig() {
  return {
    apiUrl: process.env.API_URL || 'http://localhost:8080/v1',
    userPoolId: process.env.POOL_ID || 'us-east-1_gjCdxHLSM',
    clientId: process.env.CLIENT_ID || '5bkn5lkci1i9rvujgdn5dvksbl',
    webURL: process.env.MAIN_PAGE || 'http://localhost:5001',
    domain: process.env.DOMAIN || 'localhost',
    domainAdmin: process.env.ADMIN_DOMAIN || 'localhost',
    secure: process.env.secure || false,
    adminURL: process.env.ADMIN || '/admin',
    payPublicKey: process.env.PAY_KEY || 'pk_test_9NoKrokycAYMzFh5JIXpedQD004QUSbVBN'
  }
}

export let config = getConfig()
